import { defineMessages } from 'react-intl';

export const msgs = defineMessages({
  amazon: {
    defaultMessage: `Amazon`,
  },

  checkForStreaming: {
    defaultMessage: `Check for streaming:`,
  },

  genre: {
    defaultMessage: `Genre:`,
  },

  netflix: {
    defaultMessage: `Netflix`,
  },

  synopsis: {
    defaultMessage: `Synopsis:`,
  },

  tubi: {
    defaultMessage: `Tubi`,
  },

  youtube: {
    defaultMessage: `YouTube`,
  },
});

export const da = defineMessages({
  benefits: {
    defaultMessage: `Why It's Good for Learning Danish:`,
  },
});
export const de = defineMessages({
  benefits: {
    defaultMessage: `Why It's Good for Learning German:`,
  },
});

export const el = defineMessages({
  benefits: {
    defaultMessage: `Why It's Good for Learning Greek:`,
  },
});

export const en = defineMessages({
  benefits: {
    defaultMessage: `Why It's Good for Learning English:`,
  },
});

export const en_us = defineMessages({
  benefits: {
    defaultMessage: `Why It's Good for Learning English:`,
  },
});
export const es = defineMessages({
  benefits: {
    defaultMessage: `Why It's Good for Learning Spanish:`,
  },
});
export const es_mx = defineMessages({
  benefits: {
    defaultMessage: `Why It's Good for Learning Spanish:`,
  },
});
export const fa = defineMessages({
  benefits: {
    defaultMessage: `Why It's Good for Learning Persian:`,
  },
});
export const fr = defineMessages({
  benefits: {
    defaultMessage: `Why It's Good for Learning French:`,
  },
});
export const he = defineMessages({
  benefits: {
    defaultMessage: `Why It's Good for Learning Hebrew:`,
  },
});
export const hi = defineMessages({
  benefits: {
    defaultMessage: `Why It's Good for Learning Hindi:`,
  },
});
export const id = defineMessages({
  benefits: {
    defaultMessage: `Why It's Good for Learning Indonesian:`,
  },
});
export const is = defineMessages({
  benefits: {
    defaultMessage: `Why It's Good for Learning Icelandic:`,
  },
});
export const it = defineMessages({
  benefits: {
    defaultMessage: `Why It's Good for Learning Italian:`,
  },
});
export const jp_full = defineMessages({
  benefits: {
    defaultMessage: `Why It's Good for Learning Japanese:`,
  },
});
export const jp_romaji = defineMessages({
  benefits: {
    defaultMessage: `Why It's Good for Learning Japanese:`,
  },
});
export const ko = defineMessages({
  benefits: {
    defaultMessage: `Why It's Good for Learning Korean:`,
  },
});
export const mn = defineMessages({
  benefits: {
    defaultMessage: `Why It's Good for Learning Mongolian:`,
  },
});
export const nl = defineMessages({
  benefits: {
    defaultMessage: `Why It's Good for Learning Dutch:`,
  },
});
export const no = defineMessages({
  benefits: {
    defaultMessage: `Why It's Good for Learning Norwegian:`,
  },
});
export const pl = defineMessages({
  benefits: {
    defaultMessage: `Why It's Good for Learning Polish:`,
  },
});
export const pt = defineMessages({
  benefits: {
    defaultMessage: `Why It's Good for Learning Portuguese:`,
  },
});
export const pt_br = defineMessages({
  benefits: {
    defaultMessage: `Why It's Good for Learning Portuguese:`,
  },
});
export const ru = defineMessages({
  benefits: {
    defaultMessage: `Why It's Good for Learning Russian:`,
  },
});
export const sl = defineMessages({
  benefits: {
    defaultMessage: `Why It's Good for Learning Slovenian:`,
  },
});
export const sv = defineMessages({
  benefits: {
    defaultMessage: `Why It's Good for Learning Swedish:`,
  },
});
export const sw = defineMessages({
  benefits: {
    defaultMessage: `Why It's Good for Learning Swahili:`,
  },
});
export const th = defineMessages({
  benefits: {
    defaultMessage: `Why It's Good for Learning Swedish:`,
  },
});
export const tr = defineMessages({
  benefits: {
    defaultMessage: `Why It's Good for Learning Thai:`,
  },
});
export const uk = defineMessages({
  benefits: {
    defaultMessage: `Why It's Good for Learning Ukrainian:`,
  },
});
export const yo = defineMessages({
  benefits: {
    defaultMessage: `Why It's Good for Learning Yoruba:`,
  },
});
export const zh_cn = defineMessages({
  benefits: {
    defaultMessage: `Why It's Good for Learning Chinese:`,
  },
});
